@defer (hydrate on viewport) {
  <footer>
    <app-footer-header></app-footer-header>
    <div class="content">
      <!--    <app-newsletter></app-newsletter>-->
      <app-footer-content [categories]="categories()"></app-footer-content>
    </div>
    <app-footer-bottom [categories]="bottomCategories()"></app-footer-bottom>
  </footer>
}
<app-language-popup></app-language-popup>
